/* eslint-disable no-case-declarations */

import { IPcr } from '../../pcr/store/pcr.types'
import { IItem } from '../store/timeline.types'

export const deleteAssociatedProcedure = (selectedItem: IItem, pcrDoc: IPcr): IPcr => {
  const { clientEventId, vsAction } = selectedItem

  const newTimelineItems = pcrDoc.patient.timelineItems?.filter((elem) => {
    return elem.key !== clientEventId
  })

  switch (vsAction) {
    case 'Medication':
      const medicationStateList = pcrDoc.patient.medicationAdministeredStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          medicationAdministeredStateList: medicationStateList,
          timelineItems: newTimelineItems,
        },
      }
    case 'Airway':
      const airwayStateList = pcrDoc.patient.airwayStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          airwayStateList: airwayStateList,
          timelineItems: newTimelineItems,
        },
      }
    case 'Ventilator':
      const ventilatorStateList = pcrDoc.patient.ventilatorStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          ventilatorStateList: ventilatorStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Cardiac':
      const cardiacStateList = pcrDoc.patient.cardiacStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          cardiacStateList: cardiacStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Drain':
      const drainStateList = pcrDoc.patient.drainStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          drainStateList: drainStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Initiate IV':
      const initiateIvStateList = pcrDoc.patient.initiateIvStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          initiateIvStateList: initiateIvStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Hosp. Notify':
      const hospitalNotifyStateList = pcrDoc.patient.hospitalNotifyStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          hospitalNotifyStateList: hospitalNotifyStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Intubation':
      const intubationStateList = pcrDoc.patient.intubationStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          intubationStateList: intubationStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Operations':
      const operationsStateList = pcrDoc.patient.operationsStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          operationsStateList: operationsStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Labs':
      const labsStateList = pcrDoc.patient.labsStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          labsStateList: labsStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Titrate':
      const titrateStateList = pcrDoc.patient.titrateStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          titrateStateList: titrateStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Childbirth':
      const childbirthOBStateList = pcrDoc.patient.childbirthOBStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          childbirthOBStateList: childbirthOBStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Extrication':
      const extricationStateList = pcrDoc.patient.extricationStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          extricationStateList: extricationStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Immobilization':
      const immobilizationStateList = pcrDoc.patient.immobilizationStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          immobilizationStateList: immobilizationStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Medical Consult':
      const medicalConsultStateList = pcrDoc.patient.medicalConsultStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          medicalConsultStateList: medicalConsultStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Pert Neg Med':
      const pnMedicationStateList = pcrDoc.patient.medicationAdministeredStateListPNNVs.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          medicationAdministeredStateListPNNVs: pnMedicationStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Pert Neg Proc':
      const pnProcedureStateList = pcrDoc.patient.procedureTypeStateListPNNVs.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          procedureTypeStateListPNNVs: pnProcedureStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Rescue':
      const rescueStateList = pcrDoc.patient.rescueStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          rescueStateList: rescueStateList,
          timelineItems: newTimelineItems,
        },
      }

    case 'Wound Care':
      const woundCareStateList = pcrDoc.patient.woundCareStateList.filter((elem) => {
        return elem.key !== clientEventId
      })

      return {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          woundCareStateList: woundCareStateList,
          timelineItems: newTimelineItems,
        },
      }

    default:
      return pcrDoc
  }
}
